import styled from 'styled-components';
import {
  mobile_width_percentage,
  tablet_breakpoint,
  tablet_container_maxwidth,
  desktop_breakpoint,
  desktop_container_maxwidth_compact,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const ConflictMineralStyles = styled.div`
  /* constrained-width keeps things boxed in while still 
    letting a background image or color go all the way across. */
  .constrained-width {
    margin: 0 auto;
    width: ${mobile_width_percentage}%;
  }
  .conflict-hero {
    background: url('/public-assets/images/conflict-minerals/bg-pattern.svg')
      ${Colors.primary.claytonBlue.standard} no-repeat;
    padding-bottom: 110px;
    padding-top: 97px;
    margin-bottom: 50px;
    height: 237px;
    text-align: center;
    background-position: bottom -78px right 0;

    .hero-mini-heading,
    .hero-heading,
    .hero-intro-text {
      color: #fff;
    }
  }
  .overview {
    text-align: center;
    margin-bottom: 55px;
    p {
      color: ${Colors.primary.black.standard};
      font-size: 18px;
    }
  }

  .about-conflict-minerals {
    background-color: #f7f9fb;
    h4 {
      padding-top: 23px;
    }
    .type-container {
      height: 577px;
    }
    .conflict-mineral-types {
      float: right;
      padding-top: 15px;
      margin-bottom: 20px;
    }
    p:last-of-type {
      padding-bottom: 50px;
    }
  }
  .basic-blurb {
    margin-bottom: 60px;

    .minerals-map {
      margin-bottom: 20px;
    }
    h2,
    p {
      margin-bottom: 20px;
    }
    hr {
      background-color: #e4e5e7;
      height: 1px;
      border: 0;
      margin-top: 71px;
    }
    .basic-blurb-text {
      .learn-more {
        padding-bottom: 22px;
      }
    }
  }
  .resources {
    h4 {
      padding-bottom: 20px;
    }
    svg path {
      fill: ${Colors.primary.claytonBlue.standard};
    }
    a {
      color: ${Colors.primary.claytonBlue.standard};
      text-decoration: none;
    }
  }
  .email-conflict-minerals {
    text-decoration: none;
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
    .constrained-width {
      max-width: ${tablet_container_maxwidth}px;
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .conflict-hero {
      margin-bottom: 100px;
      height: 286px;
    }
    .constrained-width {
      max-width: ${desktop_container_maxwidth_compact}px;
    }
    .basic-blurb {
      display: flex;
      justify-content: space-between;

      .basic-blurb-image {
        max-width: 496px;
        width: 50%;

        img {
          max-width: 100%;
        }
      }
      .basic-blurb-text {
        padding-top: 3%;
        width: 45%;

        h2,
        p {
          margin: 0 auto 20px auto;
        }
        .what-they-are {
          margin-top: 70px;
        }
        .learn-more {
          padding-top: 52px;
        }
      }
      .basic-blurb-text-full-width {
        padding-top: 3%;
        width: 100%;

        h2,
        p {
          margin: 0 auto 20px auto;
        }
      }
      &.basic-blurb-reverse {
        flex-direction: row-reverse;
      }
    }
  }
`;

export default ConflictMineralStyles;
